import { app } from './objects'

const constants = {
	
	  _navBreak   : 992,
	  _mobBreak   : 768,
	  _mobMenu    : 'menu-mobile',
	  _has_fixed  : 'has-fixed',
	  _is_shrink  : 'is-shrink',
	  _currentURL : window.location.href,
	  _headerHT   : (app.$header.innerHeight() - 2),
	  _splitURL   : window.location.href.split("#")

}

export { constants }